import request from '@/utils/request'

// 查询首页区域信息
export function ownership(query) {
    return request({
        url: '/system/region/ownership/statistics',
        method: 'get',
        params: query,
    })
}
// 地图排序
export function mapSort(query) {
    return request({
        url: '/fix/stat/map/sort',
        method: 'get',
        params: query,
    })
}
